import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import { useCallback, useEffect, useState } from 'react';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
const api = buildService('/my/claim_project_reports', {
  only: ['all']
});
const myProjectsService = {
  useFetchAllMyProjects: () => {
    const [myReports, setMyReports] = useState([]);
    const fetchMyReports = useErrorHandling(useCallback(async queries => {
      if (queries === undefined) return;
      const myReportsResponse = await api.all(queries);
      setMyReports(myReportsResponse.claim_project_reports);
      return myReportsResponse;
    }, []), useCallback(async () => {}, []));
    useEffect(() => {
      fetchMyReports();
    }, [fetchMyReports]);
    return {
      fetchMyReports,
      myReports,
      setMyReports
    };
  }
};
myProjectsService.useCrud = () => {
  const {
    myReports,
    setMyReports,
    fetchMyReports
  } = myProjectsService.useFetchAllMyProjects();
  return {
    myReports,
    setMyReports,
    fetchMyReports
  };
};
export default myProjectsService;